// extracted by mini-css-extract-plugin
export default {"Table":"ManufacturersTable_Table__YsuyR","EndNode":"ManufacturersTable_EndNode__D-9rH"};